<div class="view-wrapper">
    <cl-primary-bar [titleBold]="'Plant'" [titleThin]="'Design'" [toolbar]="toolbar" (titleClicked)="titleClick()">
        @if (environmentName() === 'local') {
        <div class="environment development">&#160;Local</div>
        }
        @if (environmentName() === 'development') {
        <div class="environment development">&#160;Dev</div>
        }
        @if (environmentName() === 'test') {
        <div class="environment test">&#160;Test</div>
        }
        @if (environmentName() === 'beta') {
        <div class="environment beta">&#160;Beta</div>
        }
    </cl-primary-bar>
    <router-outlet></router-outlet>
</div>

@if (featureFlagsLoading()) {
<div class="loader-container flex-column">
    <div class="flex-item rel">
        <cl-loader [isActive]="true"></cl-loader>
    </div>
</div>
}

<pd-map-settings></pd-map-settings>
<pd-confirmation-dialogue></pd-confirmation-dialogue>
<pd-placemark></pd-placemark>

<!-- Global SignalR notifications -->
<pd-global-notifications></pd-global-notifications>

@if (showUserProfileDialogue) {
<pd-user-profile-modal
    [environment]="environmentName()"
    [featureFlags]="featureFlags()"
    (closed)="closeUserProfileDialogue()">
</pd-user-profile-modal>
}
